var Theme = /** @class */ (function () {
    function Theme(modules) {
        this.modules = modules;
    }
    Theme.prototype.load = function () {
        var _this = this;
        (Object.keys(this.modules)).forEach(function (key) {
            _this.modules[key].init(_this.modules);
        });
    };
    return Theme;
}());
export { Theme };
